import { MenuResources } from './header'
import MenuItem from './menuitem'
import React from 'react'

interface MegaMenuProps {
  handleToggle?: (index: string) => void
  clicked?: string
  setIsDrawerOpen?: (open: boolean) => void
  menuData: MenuResources[]
  isDrawerOpen?: boolean
}

const MegaMenu: React.FC<MegaMenuProps> = ({
  handleToggle,
  clicked,
  setIsDrawerOpen,
  menuData,
  isDrawerOpen
}) => {

  function getTitleValue(obj: any) {
    if (obj.title && typeof obj.title === 'object') {
      return Object.values(obj.title)[0]
    }
    return null
  }

  return (
    <div className="nav__container">
      <nav aria-label={String(getTitleValue(menuData[0]) || "")}>
        <ul className='!my-0'>
          {menuData.map(({ title, link, children }, index) => {
            return (
              <MenuItem
                key={getTitleValue(menuData[0]).toString()}
                {...{
                  title,
                  link,
                  children,
                  setIsDrawerOpen,
                }}
                onToggle={() => handleToggle && handleToggle(getTitleValue(menuData[0]).toString())}
                active={clicked === getTitleValue(menuData[0]).toString()}
                tabIndex={isDrawerOpen ? 0 : -1}
              />
            )
          })}
        </ul>
      </nav>
    </div>
  )
}

export default MegaMenu